<template>
    <v-card-text class="pt-2 pb-0">
        <v-btn-toggle
                v-model="carTypeSelect"
                dense
                mandatory
                background-color="primary"
                class="change_dtype mt-2 mb-3"
        >
            <v-btn
                v-for="(item,i) in filtrCarTypes"
                :key="item.id"
                :value="item.id"
                :disabled="item.disable"
                class="pa-0"
            >
              <img
                  :src="'/images/icons/'+ (i+1) + '.png'"
                  :alt="item.name"
                  style="max-width: 60px"
              >
<!--              <v-icon class="mx-5">mdi-{{item.icon}}</v-icon>-->
            </v-btn>

        </v-btn-toggle>
        <p class="subtitle-1 mb-0">Колеса</p>
        <v-card
                class="px-3 primary_bg_color"
                transparent
                outlined
        >
            <v-row>
                <v-col>
                    <v-btn class="ml-auto mr-2" @click="solidDisk = false" height="51px" width="80px" :class="solidDisk?'':'active'">
                        <v-img :src="icon[0]" aspect-ratio="2" contain class="tabs_icons_big" alt="Штампованый диск"></v-img>
                    </v-btn>
                    <v-btn class="mr-auto" @click="solidDisk = true" height="51px" width="80px"  :class="solidDisk?'active':''">
                        <v-img :src="icon[1]" aspect-ratio="2" contain class="tabs_icons_big" alt="Литой диск"></v-img>
                    </v-btn>
                </v-col>
                <v-col class="d-flex">
                    <v-card height="51px" width="250px" class="v-btn text-center ml-2" :class="frameVehicle?'active':''" @click="changFrameVehicle">
                        <div class="pa-1">
                            <div class="btn-text-top">
                                Рамный автомобиль
                            </div>
                            <div class="btn-text-bottom">
                              или профиль от 70 и выше
                            </div>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-btn v-for="(item, index) in availableTire" :key="index" class="ml-3 mr-3 mb-3" :class="tireList[item]==radius?'active':''" @click="radius=tireList[item]">
                        R{{ tireList[item] }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-card-text>
</template>
<script>
    export default {
        name: 'wheelRadius',
        props: ['side', 'typeselected'],
        data() {
            return {
                icon:[
                    require('../../../assets/shtamp.png'),
                    require('../../../assets/litie.png')
                ],
            }
        },
        mounted() {
          this.$store.dispatch('fetchCarSTypesByService')
        },
        computed: {
            frameVehicle: {
                get() {
                    return this.$store.state.change.wheels[this.side][this.typeselected].data.isFrameVehicle
                },
                set(value) {
                    this.$store.commit('change/setIsFrameVehicle', { side: this.side, type:this.typeselected, value })
                }
            },
            carType () {
                return this.$store.state.change['carType']
            },
            carTypeByService () {
                return this.$store.state.clientCard.carTypesByService
            },
            filtrCarTypes () {
              if (this.carTypeByService) {
                let selectedTypes = this.carTypeByService.filter(carType => carType.service.slug === this.choosenDirSlug)
                if (!selectedTypes) {
                  selectedTypes = this.carTypes[0]
                }
                selectedTypes.forEach(type => {
                  if (!this.$store.state.change.ChangePrice[this.typeselected]['availableTire'][type.id]) {
                    type.disable = true
                  } else {
                    type.disable = false
                  }
                })
                return selectedTypes
              } else {
                return []
              }
            },
            choosenDirSlug () {
              return this.$store.getters['login/chosenDirectionSlug']
            },
            carTypeSelect: {
                get() {
                    return this.$store.state.change.wheels[this.side][this.typeselected].data.carType
                },
                set(value) {
                    this.$store.commit('change/setCarType', { side: this.side, type: this.typeselected, value })
                }
            },
            tireList () {
                return this.$store.state.change.tireName
            },
            radius: {
                get() {
                    return this.$store.state.change.wheels[this.side][this.typeselected].data.radius
                },
                set(value) {
                    this.$store.dispatch('change/setRadius', { side: this.side, type:this.typeselected, value })
                }
            },
            isRunflat: {
                get() {
                    return this.$store.state.change.wheels[this.side][this.typeselected].data.isRunflat
                },
                set(value) {
                    this.$store.commit('change/setIsRunflat', { side: this.side, type:this.typeselected, value })
                }
            },
            solidDisk: {
                get() {
                    return this.$store.state.change.wheels[this.side][this.typeselected].data.solidDisk
                },
                set(value) {
                    this.$store.dispatch('change/changeWheelDiskType', { side: this.side, type:this.typeselected, value })
                }
            },
            availableTire () {
                return this.$store.state.change.ChangePrice[this.typeselected]['availableTire'][this.carTypeSelect]
            },
        },
        methods: {
          changFrameVehicle () {
            this.frameVehicle = !this.frameVehicle
            this.$store.dispatch('change/changePrice', {
              runflat: this.isRunflat,
              frameVehicle: this.frameVehicle,
            })
          },
          changeRunflat () {
            this.isRunflat = !this.isRunflat
            this.$store.dispatch('change/changePrice', {
              runflat: this.isRunflat,
              frameVehicle: this.frameVehicle,
            })
          }
        }
    }
</script>
<style lang="scss">
    .bottom_line {
        border-bottom: #D8D8D8 1px solid;
    }
    .primary_bg_color {
        background-color: #FFFEEE !important;
    }
    .primary_bg_color .active {
        background-color: #FFFBCD !important;
    }
    .change_disk.v-btn-toggle .v-btn{
        height: 51px !important;
        width: 80px !important;
    }
    .change_disk.v-btn-toggle{
        height: 51px !important;
        width: 80px !important;
    }
    .tabs_icons_big {
        width: 40px;
        height: 40px;
    }
</style>
